import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ContentGeneration from './components/ContentGeneration';

const contentGeneration = (props,{ t }) => (
  <Container>
    <ContentGeneration {...props} />
  </Container>
);

contentGeneration.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(contentGeneration);
